import { useEffect, useRef, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { classList, paymentModes } from "../../utils";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdmissionFormDetails } from "../../redux/admissionFormSlice";
import { getDecodedToken } from "../../auth";
import AdmissionFeeReceipt from "../../components/AdmissionFeeReceipt";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getSession } from "../../functions";

function AdmissionForm() {
  const [user, setUser] = useState(null);
  const dateInputRef = useRef(null);

  useEffect(() => {
    const decodedData = getDecodedToken();
    if (decodedData) {
      setUser(decodedData);
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user?.userId) {
      setFormData((prev) => ({
        ...prev,
        collectedBy: user.userId,
      }));
      setLoading(false);
    }
  }, [user]);

  const paymentModeLabels = {
    UPI: "UPI ID",
    NEFT: "UTR No",
    Cheque: "Cheque No",
    "Card Swap": "Card Last 4 Digit No",
    "Net Banking": "Reference ID",
  };

  const bankApplicableModes = [
    "NEFT",
    "Card Swap",
    "Net Banking",
    "Cheque",
    "UPI",
  ];

  const handleDownloadReceipt = async (receiptData) => {
    try {
      AdmissionFeeReceipt([receiptData]);
    } catch (error) {
      console.error("Error generating receipt:", error);
    }
  };

  const [formData, setFormData] = useState({
    session: getSession() || "N/A",
    formNo: "",
    applyDate: new Date().toLocaleDateString("en-GB"),
    submissionDate: "",
    student: {
      name: "",
      Class: "",
      fatherName: "",
      contactNo: "",
      gender: "",
      address: "",
    },
    examination: {
      date: "",
      appeared: false,
      remarks: "",
    },
    interview1: {
      date: "",
      remarks: "",
    },
    interview2: {
      date: "",
      remarks: "",
    },
    selected: "",
    amount: "500",
    mode: "",
    paymentId: "",
    bank: "",
    collectedBy: user?.userId,
  });

  const dispatch = useDispatch();
  const { data: admissionFormDetails, loading: fetchLoading } = useSelector(
    (state) => state.admissionForm,
  );

  useEffect(() => {
    dispatch(fetchAdmissionFormDetails());
  }, [dispatch]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const MySwal = withReactContent(Swal);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const recordsPerPage = 10;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [section, field] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const getInitialFormData = () => ({
    session: getSession() || "N/A",
    formNo: "",
    applyDate: new Date().toLocaleDateString("en-GB"),
    submissionDate: "",
    student: {
      name: "",
      Class: "",
      fatherName: "",
      contactNo: "",
      gender: "",
      address: "",
    },
    examination: { date: "", appeared: false, remarks: "" },
    interview1: { date: "", remarks: "" },
    interview2: { date: "", remarks: "" },
    selected: "",
    amount: "500",
    mode: "",
    paymentId: "",
    bank: "",
    collectedBy: user?.userId,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${server}/add_admissionForm_mongodb`, formData, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      toast.success("Admission Form Sold", { position: "top-right" });

      dispatch(fetchAdmissionFormDetails());

      const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
      if (closeButton) closeButton.click();

      setFormData(getInitialFormData());
      setError({});
    } catch (error) {
      toast.error(error?.response?.data?.message || "Please Try Again", {
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async (formNo) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to mark this form as submitted?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Submitted",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });

    if (confirmResult.isConfirmed) {
      try {
        const response = await axios.put(
          "https://7otfgyv0ke.execute-api.ap-south-1.amazonaws.com/prod/UpdateStatusOfAdmissionForm",
          { formNo, submitted: true },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${localStorage.getItem("token")}`,
            },
          },
        );

        toast.success("Updated, Form Submission", { position: "top-right" });
        dispatch(fetchAdmissionFormDetails());
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Could not update Form Status",
        });
      }
    }
  };

  const totalFields = Object.keys(formData.student).length;
  const filledFields = Object.values(formData.student).filter(
    (val) =>
      (typeof val === "string" && val.trim() !== "") ||
      (typeof val === "number" && val > 0),
  ).length;

  // Filter
  const filteredRecords = admissionFormDetails.filter((feesMaster) => {
    const searchLower = searchTerm.toLowerCase();

    return Object.values(feesMaster || {}).some(
      (value) =>
        typeof value === "string" && value.toLowerCase().includes(searchLower),
    );
  });

  // Calculate pagination
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  // Page Navigation
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleDownloadExcel = (type) => {
    if (!admissionFormDetails || admissionFormDetails.length === 0) {
      toast.error("No admission form data available.");
      return;
    }

    const formatData = (data) =>
      data.map((item) => ({
        "Form No": item.formNo || "",
        "Apply Date": item.applyDate || "",
        "Submission Date": item.submissionDate || "",
        "Student Name": item?.student?.name || "",
        "Father Name": item?.student?.fatherName || "",
        Gender: item?.student?.gender || "",
        Class: item?.student?.Class || "",
        "Contact No": item?.student?.contactNo || "",
        Address: item?.student?.address || "",
        Amount: item.amount || "",
        "Mode of Payment": item.mode || "",
        "Payment ID": item.paymentId || "",
        Bank: item.bank || "",
        "Collected By": item.collectedBy || "",
        Submitted: item.submitted ? "Yes" : "No",
      }));

    const workbook = XLSX.utils.book_new();

    // ✅ Case 1 — All data
    if (type === "all") {
      const wsAll = XLSX.utils.json_to_sheet(formatData(admissionFormDetails));
      XLSX.utils.book_append_sheet(workbook, wsAll, "All Admissions");
    }

    // ✅ Case 2 — Class-wise
    if (type === "class") {
      const classGroups = {};
      admissionFormDetails.forEach((rec) => {
        const cls = rec.student?.Class || "Unspecified";
        if (!classGroups[cls]) classGroups[cls] = [];
        classGroups[cls].push(rec);
      });

      Object.entries(classGroups).forEach(([cls, data]) => {
        const ws = XLSX.utils.json_to_sheet(formatData(data));
        XLSX.utils.book_append_sheet(workbook, ws, `${cls}`);
      });
    }

    // ✅ Case 3 — Gender-wise
    if (type === "gender") {
      const male = admissionFormDetails.filter(
        (r) => r.student?.gender === "Male",
      );
      const female = admissionFormDetails.filter(
        (r) => r.student?.gender === "Female",
      );

      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(formatData(male)),
        "Male",
      );
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(formatData(female)),
        "Female",
      );
    }

    // ✅ Case 4 — Month-wise
    if (type === "month") {
      const monthGroups = {};
      admissionFormDetails.forEach((rec) => {
        const date = rec.applyDate || "";
        const month = date.split("/")[1] || "Unknown";
        const monthName = new Date(2025, month - 1).toLocaleString("default", {
          month: "long",
        });
        if (!monthGroups[monthName]) monthGroups[monthName] = [];
        monthGroups[monthName].push(rec);
      });

      Object.entries(monthGroups).forEach(([month, data]) => {
        const ws = XLSX.utils.json_to_sheet(formatData(data));
        XLSX.utils.book_append_sheet(workbook, ws, month);
      });
    }

    // ✅ Case 5 — Submitted / Not Submitted Report
    if (type === "submitted") {
      const submitted = admissionFormDetails.filter(
        (r) => r.submitted === true,
      );
      const notSubmitted = admissionFormDetails.filter(
        (r) => !r.submitted || r.submitted === false,
      );

      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(formatData(submitted)),
        "Submitted",
      );
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(formatData(notSubmitted)),
        "Not Submitted",
      );
    }

    // ✅ File Naming
    const reportNameMap = {
      all: "All_Admission_Form_Report",
      class: "Class_Wise_Admission_Report",
      gender: "Gender_Wise_Admission_Report",
      month: "Month_Wise_Admission_Report",
      submitted: "Submitted_Status_Report",
    };

    const fileName = `${reportNameMap[type] || "Admission_Report"}.xlsx`;

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    toast.success(`Report Generated`);
    saveAs(blob, fileName);
  };

  const handleDownloadDateWiseReport = () => {
    const selectedDate = dateInputRef.current?.value;

    if (!selectedDate) {
      toast.error("Please select a date first.");
      return;
    }

    // Convert to dd/mm/yyyy
    const formattedDate = new Date(selectedDate).toLocaleDateString("en-GB");

    const filteredData = admissionFormDetails.filter(
      (item) => item.applyDate === formattedDate,
    );

    if (filteredData.length === 0) {
      toast.info(`No records found for ${formattedDate}.`);
      return;
    }

    const formatData = (data) =>
      data.map((item) => ({
        "Form No": item.formNo || "",
        "Apply Date": item.applyDate || "",
        "Submission Date": item.submissionDate || "",
        "Student Name": item?.student?.name || "",
        "Father Name": item?.student?.fatherName || "",
        Gender: item?.student?.gender || "",
        Class: item?.student?.Class || "",
        "Contact No": item?.student?.contactNo || "",
        Address: item?.student?.address || "",
        Amount: item.amount || "",
        "Mode of Payment": item.mode || "",
        "Payment ID": item.paymentId || "",
        Bank: item.bank || "",
        "Collected By": item.collectedBy || "",
        Submitted: item.submitted ? "Yes" : "No",
      }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(formatData(filteredData));

    // ✅ Safe sheet name (no special characters)
    const safeSheetName = formattedDate.replaceAll("/", "-");
    XLSX.utils.book_append_sheet(workbook, worksheet, safeSheetName);

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const fileName = `Admission_Report_${safeSheetName}.xlsx`;
    saveAs(blob, fileName);

    toast.success(`Report Generated for ${formattedDate}`);
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div
              class="modal fade gd-example-modal-lg"
              tabindex="-1"
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <form onSubmit={handleSubmit}>
                    <div class="modal-header d-flex justify-content-between">
                      <h5 class="modal-title fs-4" id="exampleModalToggleLabel">
                        Sell Admission Form{" "}
                        <span className="ms-3 text-secondary">
                          ({String(filledFields).padStart(2, "0")}/
                          {String(totalFields).padStart(2, "0")})
                        </span>
                      </h5>
                      <div className="d-flex align-items-center">
                        <span class="badge bg-success-soft me-3 px-3">
                          Editable
                        </span>
                        <div class="form-check form-switch me-4">
                          <input
                            type="checkbox"
                            class="form-check-input m-0"
                            checked
                          />
                        </div>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                    </div>

                    <div class="modal-body">
                      <div className="row g-2 mb-2">
                        <div className="col-lg-6 col-12">
                          <label className="form-label mb-1 ms-3">
                            Session <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            name="session"
                            value={formData.session}
                            readOnly
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Apply Date <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            placeholder="Enter Receipt Date"
                            value={formData.applyDate}
                            readOnly
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Form Number
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            placeholder="Enter Form Number"
                            name="formNo"
                            value={formData.formNo}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Student Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            placeholder="Enter Student Name"
                            name="student.name"
                            value={formData.student.name}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Class <span className="text-danger">*</span>
                          </label>
                          <Select
                            name="student.Class"
                            value={
                              classList
                                .map((cls) => ({
                                  label: cls,
                                  value: cls.toUpperCase(),
                                }))
                                .find(
                                  (opt) => opt.value === formData.student.Class,
                                ) || null
                            }
                            onChange={(selected) =>
                              handleChange({
                                target: {
                                  name: "student.Class",
                                  value: selected?.value || "",
                                },
                              })
                            }
                            options={classList.map((cls) => ({
                              label: cls,
                              value: cls.toUpperCase(),
                            }))}
                            placeholder="Select Class"
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Select Gender <span className="text-danger">*</span>
                          </label>
                          <Select
                            name="student.gender"
                            options={[
                              { label: "Male", value: "Male" },
                              { label: "Female", value: "Female" },
                            ]}
                            value={
                              ["Male", "Female"]
                                .map((g) => ({ label: g, value: g }))
                                .find(
                                  (opt) =>
                                    opt.value === formData.student.gender,
                                ) || null
                            }
                            onChange={(selected) =>
                              handleChange({
                                target: {
                                  name: "student.gender",
                                  value: selected?.value || "",
                                },
                              })
                            }
                            placeholder="Select Gender"
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Father Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            placeholder="Enter Father Name"
                            name="student.fatherName"
                            value={formData.student.fatherName}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Mobile No <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            placeholder="Enter Mobile No"
                            name="student.contactNo"
                            value={formData.student.contactNo}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Submission Date{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control text-dark"
                            placeholder="Enter Submission Date"
                            name="submissionDate"
                            value={formData.submissionDate}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-lg-6 col-12">
                          <label class="form-label mb-1 ms-3">
                            Address <span className="text-danger">*</span>
                          </label>
                          <textarea
                            type="text"
                            class="form-control text-dark"
                            placeholder="Enter Address"
                            name="student.address"
                            value={formData.student.address}
                            onChange={handleChange}
                            required
                            rows="3"
                          ></textarea>
                        </div>
                        {/* Amount */}
                        <div className="col-lg-6 col-12">
                          <label className="form-label mb-1 ms-3">
                            Amount <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control text-dark"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            placeholder="Enter Amount"
                            readOnly
                          />
                        </div>

                        {/* Payment Mode */}
                        <div className="col-lg-6 col-12">
                          <label className="form-label mb-1 ms-3">
                            Payment Mode <span className="text-danger">*</span>
                          </label>
                          <Select
                            name="mode"
                            value={
                              paymentModes
                                .map((mode) => ({ label: mode, value: mode }))
                                .find((opt) => opt.value === formData.mode) ||
                              null
                            }
                            onChange={(selected) => {
                              const selectedMode = selected?.value || "";
                              setFormData((prev) => ({
                                ...prev,
                                mode: selectedMode,
                                paymentId: "",
                                bank: bankApplicableModes.includes(selectedMode)
                                  ? prev.bank
                                  : "",
                              }));
                            }}
                            options={paymentModes.map((mode) => ({
                              label: mode,
                              value: mode,
                            }))}
                            placeholder="Select Payment Mode"
                          />
                        </div>

                        {/* Payment ID / UTR / Cheque No */}
                        {formData.mode && formData.mode !== "Cash" && (
                          <div className="col-6">
                            <label className="form-label mb-1 ms-3">
                              {paymentModeLabels[formData.mode] ||
                                "Reference No"}{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control text-dark"
                              name="paymentId"
                              value={formData.paymentId}
                              onChange={handleChange}
                              placeholder={`Enter ${
                                paymentModeLabels[formData.mode] ||
                                "Reference No"
                              }`}
                            />
                          </div>
                        )}

                        {/* Bank Field for Specific Modes */}
                        {bankApplicableModes.includes(formData.mode) && (
                          <div className="col-6">
                            <label className="form-label mb-1 ms-3">
                              Bank <span className="text-danger">*</span>
                            </label>
                            <Select
                              name="bank"
                              className="text-dark"
                              value={
                                [
                                  { value: "HDFC", label: "HDFC Bank" },
                                  {
                                    value: "PNB",
                                    label: "Punjab National Bank (PNB)",
                                  },
                                ].find((b) => b.value === formData.bank) || null
                              }
                              onChange={(selectedOption) =>
                                handleChange({
                                  target: {
                                    name: "bank",
                                    value: selectedOption?.value || "",
                                  },
                                })
                              }
                              options={[
                                { value: "HDFC", label: "HDFC Bank" },
                                {
                                  value: "PNB",
                                  label: "Punjab National Bank (PNB)",
                                },
                              ]}
                              placeholder="Select Bank"
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div class="modal-footer d-flex justify-content-between py-2">
                      <div>
                        <button
                          type="button"
                          class="btn btn-secondary px-3 me-1 rounded-pill"
                          data-bs-dismiss="modal"
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                        <button
                          type="submit"
                          class="btn btn-primary px-5 rounded-pill fw-normal"
                          disabled={loading}
                        >
                          {loading ? (
                            <div
                              class="spinner-border spinner-border-sm"
                              role="status"
                            ></div>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="">
              <div class="container-fluid my-3 px-3">
                <div className="row g-2">
                  <div className="col-lg-8">
                    <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
                      <table class="table mb-0 text-nowrap table-centered">
                        <thead class="table-light">
                          <tr>
                            <th className="w-10">No.</th>
                            <th className="lh-1 w-60">
                              Details
                              <i className="bi bi-info-circle ms-2 text-dark"></i>
                              <br />
                              <span className="fs-8 fw-normal text-secondary">
                                Displaying Information as per Record
                              </span>
                            </th>
                            <th className="lh-1 w-30">
                              Action
                              <i className="bi bi-person-gear ms-2 text-dark"></i>
                              <br />
                              <span className="fs-8 fw-normal text-secondary">
                                Role-Specific Action Panel
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentRecords.map((feesMaster, index) => (
                            <tr key={index}>
                              <td>{indexOfFirstRecord + index + 1}.</td>
                              <td className="lh-sm py-4 text-wrap">
                                <span class="text-dark">Apply Date</span>{" "}
                                &mdash;{" "}
                                <span className="text-capitalize">
                                  {feesMaster.applyDate}
                                </span>
                                <br />
                                <span class="text-dark">
                                  Form No
                                </span> &mdash;{" "}
                                <span className="text-capitalize">
                                  {feesMaster?.formNo}
                                </span>
                                <br />
                                <span class="text-dark">Student Name</span>{" "}
                                &mdash; {feesMaster?.student?.name}
                                <br />
                                <span class="text-dark">
                                  Gender
                                </span> &mdash; {feesMaster?.student?.gender}
                                <br />
                                <span class="text-dark">
                                  Class
                                </span> &mdash; {feesMaster?.student?.Class}
                                <br />
                                <span class="text-dark">
                                  Father's Name
                                </span>{" "}
                                &mdash; {feesMaster?.student?.fatherName}
                                <br />
                                <span class="text-dark">Contact No</span>{" "}
                                &mdash; {feesMaster?.student?.contactNo}
                                <hr className="w-25" />
                                <span class="text-dark">
                                  Amount
                                </span> &mdash; {feesMaster?.amount}
                                <br />
                                <span className="text-dark">
                                  Mode Of Payment
                                </span>{" "}
                                &mdash; {feesMaster?.mode}
                                <br />
                                {feesMaster?.mode !== "Cash" && (
                                  <>
                                    <span className="text-dark">
                                      Payment ID
                                    </span>{" "}
                                    &mdash; {feesMaster?.paymentId || "—"}
                                    <br />
                                    <span className="text-dark">Bank</span>{" "}
                                    &mdash; {feesMaster?.bank || "—"}
                                    <br />
                                  </>
                                )}
                                <span class="text-dark">Collected By</span>{" "}
                                &mdash; {feesMaster?.collectedBy}
                                <br />
                                <div className="mt-2 d-flex align-items-center">
                                  <span
                                    className={`badge-dot me-2 d-inline-block align-middle ${
                                      feesMaster?.submitted
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  ></span>
                                  <span className="text-capitalize">
                                    {feesMaster?.submitted
                                      ? "Submitted"
                                      : "Not Submitted"}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column gap-1 width-fit-content">
                                  <span
                                    onClick={() =>
                                      handleDownloadReceipt(feesMaster)
                                    }
                                    class="badge bg-success-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                  >
                                    Download
                                  </span>
                                  {!feesMaster?.submitted && (
                                    <span
                                      className="badge bg-dark-soft cursor-pointer px-4 rounded-3 btn-py-sm"
                                      onClick={() =>
                                        handleUpdateStatus(feesMaster?.formNo)
                                      }
                                    >
                                      Submitted
                                    </span>
                                  )}
                                  <span class="badge bg-warning-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                    Update
                                  </span>
                                  <span class="badge bg-info-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                    Send Reminder
                                  </span>
                                  <div className="d-flex justify-content-center">
                                    <hr className="w-50" />
                                  </div>
                                  <span class="badge bg-danger-soft cursor-pointer px-4 rounded-3 btn-py-sm">
                                    Delete
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div class="">
                      <div className="mb-3">
                        <div className="d-flex bg-white justify-content-between rounded-4">
                          <form
                            className="d-flex align-items-center"
                            onSubmit={(e) => e.preventDefault()}
                          >
                            <span className="position-absolute ps-3 search-icon">
                              <i className="bi bi-filter-circle-fill ms-1" />
                            </span>
                            <input
                              type="search"
                              className="form-control ps-7 rounded-3 border-0 rounded-4"
                              placeholder="Filter Data"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </form>
                          <Link
                            data-bs-toggle="modal"
                            data-bs-target=".gd-example-modal-lg"
                            className="btn btn-warning px-5 fs-6 fw-medium rounded-4 fit-content"
                          >
                            Sell Admission Form
                          </Link>
                        </div>
                        <div className="mt-2 ms-4">
                          <nav aria-label="breadcrumb">
                            <ol class="breadcrumb pe-3">
                              <li class="breadcrumb-item">
                                <a href="#">Fees Collection</a>
                              </li>
                              <li
                                class="breadcrumb-item active"
                                aria-current="page"
                              >
                                Admission Form
                              </li>
                            </ol>
                          </nav>
                        </div>
                      </div>

                      <div className="p-4 bg-white rounded-4">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            {fetchLoading ? (
                              <div
                                className="spinner-border text-dark data-loader-spinner"
                                role="status"
                              ></div>
                            ) : (
                              <img src="/assets/images/folder.svg" />
                            )}

                            <p className="my-0 fw-semibold lh-1 fs-5 text-dark mx-3">
                              Admission Form
                              <br />
                              <span className="text-secondary fs-6 fw-medium lh-sm">
                                0.6 MB Size
                              </span>
                            </p>
                          </div>
                          <span className="badge bg-pink rounded-3 px-4 py-2 me-1 mt-1 cursor-pointer">
                            Export
                          </span>
                        </div>

                        <div class="px-4 py-2 mt-3 bg-light rounded-4">
                          <li className="list-group-item px-0">
                            <a
                              className="d-flex align-items-center text-inherit mb-0 justify-content-between"
                              data-bs-toggle="collapse"
                              href="#specifications"
                              role="button"
                              aria-expanded="false"
                              aria-controls="specifications"
                            >
                              <p className="m-0 fw-medium lh-sm text-dark">
                                Download Report
                              </p>
                              <span className="chevron-arrow ms-4">
                                <i className="bi bi-chevron-down fs-4" />
                              </span>
                            </a>
                            <div
                              className="collapse"
                              id="specifications"
                              data-bs-parent="#ecommerceAccordion"
                            >
                              <div className="py-3">
                                <div className="rounded-4 d-flex flex-wrap">
                                  <span
                                    className="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                    onClick={() => handleDownloadExcel("all")}
                                  >
                                    All Admission Form Report
                                  </span>
                                  <span
                                    className="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                    onClick={() => handleDownloadExcel("class")}
                                  >
                                    Class Wise
                                  </span>
                                  <span
                                    className="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                    onClick={() =>
                                      handleDownloadExcel("submitted")
                                    }
                                  >
                                    Submitted / Not Submitted
                                  </span>
                                  <span
                                    className="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                    onClick={() =>
                                      handleDownloadExcel("gender")
                                    }
                                  >
                                    Gender Wise
                                  </span>
                                  <span
                                    className="btn btn-outline-primary btn-sm px-4 rounded-3 mb-1 me-1"
                                    onClick={() => handleDownloadExcel("month")}
                                  >
                                    Month Wise Report
                                  </span>
                                </div>
                              </div>
                            </div>
                          </li>
                        </div>

                        <div className="bg-secondary-soft rounded-4 py-3 px-4 mt-1">
                          <div>
                            <input
                              type="date"
                              className="form-control ps-4 pe-5 border-0 rounded-pill"
                              placeholder="..."
                              ref={dateInputRef}
                            />
                          </div>
                          <span
                            className="btn btn-primary btn-sm px-4 rounded-pill mt-2 me-1"
                            onClick={() => handleDownloadDateWiseReport()}
                          >
                            Download Report
                          </span>
                        </div>
                      </div>

                      <div className="my-4">
                        <nav>
                          <ul className="pagination justify-content-center mb-0">
                            <li
                              className={`page-item ${
                                currentPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <button className="page-link" onClick={prevPage}>
                                <i className="bi bi-chevron-left"></i>
                              </button>
                            </li>

                            {(() => {
                              const pageNumbers = [];
                              pageNumbers.push(1);

                              if (currentPage > 3) {
                                pageNumbers.push("left-ellipsis");
                              }

                              if (
                                currentPage !== 1 &&
                                currentPage !== totalPages
                              ) {
                                pageNumbers.push(currentPage);
                              }

                              if (currentPage < totalPages - 2) {
                                pageNumbers.push("right-ellipsis");
                              }

                              if (totalPages > 1) {
                                pageNumbers.push(totalPages);
                              }

                              return pageNumbers.map((page, index) => {
                                if (
                                  page === "left-ellipsis" ||
                                  page === "right-ellipsis"
                                ) {
                                  return (
                                    <li
                                      key={index}
                                      className="page-item disabled"
                                    >
                                      <span className="page-link">...</span>
                                    </li>
                                  );
                                }

                                return (
                                  <li
                                    key={index}
                                    className={`page-item ${
                                      currentPage === page ? "active" : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => setCurrentPage(page)}
                                    >
                                      {page}
                                    </button>
                                  </li>
                                );
                              });
                            })()}

                            <li
                              className={`page-item ${
                                currentPage === totalPages ? "disabled" : ""
                              }`}
                            >
                              <button className="page-link" onClick={nextPage}>
                                <i className="bi bi-chevron-right"></i>
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default AdmissionForm;
